import React, { useState, useContext, useEffect, useRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { obtenerReviews } from "../Services/reviewsServices";
import { fechaBase } from "../Script/script";

const Alumno = () => {
  const [snackVisible, setSnack] = useState(false);
  const [inscripcion, setInscripcion] = useState({});

  var time = useRef();
  var alumnos = [];

  useEffect(() => {
    //cargarAlumnos();
  }, []);

  const cargarAlumnos = async () => {
    const { data: alumno } = await obtenerReviews("2069857");
    alumnos = await alumno.results.filter((r) => r.rating >= 4);
    //console.log(alumnos);
    obtenerAlumno();
  };
  const obtenerAlumno = async () => {
    const indice = Math.floor(Math.random() * (50 - 0 + 1)) + 0;
    setInscripcion({
      nombre: alumnos[indice].user.display_name,
      fecha: alumnos[indice].user_modified,
    });
    mostrarAlumno();
  };

  const mostrarAlumno = async () => {
    time.current = setTimeout(() => {
      setSnack(true);
      ocultarAlumno();
      return () => {
        clearTimeout(time);
      };
    }, 15000);
  };
  const ocultarAlumno = async () => {
    time.current = setTimeout(() => {
      setSnack(false);
      obtenerAlumno();
    }, 6000);
    return () => clearTimeout(time);
  };

  const [msg, setMsg] = useState({
    show: false,
    vertical: "bottom",
    horizontal: "left",
  });

  const { vertical, horizontal, show } = msg;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack(false);
  };

  return (
    <Snackbar
      open={snackVisible}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      key={vertical + horizontal}
    >
      <Alert
        elevation={6}
        severity={"success"}
        icon={<AccountCircle />}
        variant="filled"
        sx={{ backgroundColor: "#ED6C02", width: "100%" }}
      >
        {snackVisible &&
          inscripcion.nombre +
            " se inscribió el " +
            fechaBase(inscripcion.fecha, "DD/MM/YYYY")}
      </Alert>
    </Snackbar>
  );
};

export default Alumno;
